import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { FeatureFlagsService } from "./shared/feature-flags.service";
import {
  FeatureFlags,
  FeatureFlagKey,
  FeatureFlagInfo,
  FEATURE_FLAG_INFO,
} from "./shared/feature-flags.model";

@Component({
  selector: "app-agilx",
  templateUrl: "./agilx.component.html",
  styleUrls: ["./agilx.component.css"],
})
export class AgilxComponent implements OnInit, OnDestroy {
  featureFlags: FeatureFlags;
  featureFlagInfo: FeatureFlagInfo[] = FEATURE_FLAG_INFO;

  private destroy$ = new Subject<void>();

  constructor(private featureFlagsService: FeatureFlagsService) {}

  ngOnInit(): void {
    this.featureFlagsService.featureFlags$.pipe(takeUntil(this.destroy$)).subscribe((flags) => {
      this.featureFlags = flags;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onToggle(feature: FeatureFlagKey): void {
    this.featureFlagsService.toggleFeature(feature);
  }

  enableAll(): void {
    this.featureFlagsService.enableAll();
  }

  disableAll(): void {
    this.featureFlagsService.disableAll();
  }

  getEnabledCount(): number {
    if (!this.featureFlags) return 0;
    return Object.values(this.featureFlags).filter((v) => v).length;
  }

  getTotalCount(): number {
    return this.featureFlagInfo.length;
  }
}
